import {Injectable} from "@angular/core";
import {IQuestionEntry, QuestionType, IAnswer} from "../../api/data-model";
import {Observable} from "rxjs";
import {SessionService} from "../configuration/session.service";
import {QuestionEvaluation, IAnswerModel} from "../../questions/question.component";
import {AnswerPresentationService} from "./answer.presentation.service";
import {Scilearn} from "../../constants";

@Injectable()
export class QuestionService {

    private questionEntries:IQuestionEntry[] = [];
    private taqEntries:IQuestionEntry[] = [];
    private quizEntries:IQuestionEntry[] = [];
    private taqEntriesOriginal:IQuestionEntry[] = [];
    private quizEntriesOriginal:IQuestionEntry[] = [];

    constructor(private session:SessionService,
                private answerPresentationService:AnswerPresentationService) {
    }

    public injectEntries(entries:IQuestionEntry[], isPipeline: boolean):void {
        this.questionEntries = entries;
        this.taqEntries = this.determineTaqEntries(isPipeline);
        this.quizEntries = this.determineQuizEntries(isPipeline);
        console.log("Completed taq and quiz setup.");
    }

    public retrieveQuiz():IQuestionEntry[] {
        return this.quizEntries;
    }

    public retrieveTAQs():IQuestionEntry[] {
        return this.taqEntries;
    }

    public retrieveQuestion(id:string):IQuestionEntry {
        return this.questionEntries.find(entry => entry.id === id);
    }

    public retrieveQuestionIndex(entry:IQuestionEntry):string {
        if (!entry) {
            return "";
        }
        if (entry.presentation === Scilearn.QUIZ_QUESTION) {
            return this.quizEntries.indexOf(entry).toString();
        } else {
            return this.taqEntries.indexOf(entry).toString();
        }
    }

    public submitAnswer(entry:IQuestionEntry, evaluation:QuestionEvaluation, duration:number,
                        successCallback:Function):Observable<string> {

        if ((entry.type !== "OpenBook") && (entry.type !== "Prompt")) {
            evaluation.userAnswer = this.mapToOriginalIndices(entry, evaluation.userAnswer);
            evaluation.correctAnswer = this.mapToOriginalIndices(entry, evaluation.correctAnswer);
        }

        let uploadAnswer = evaluation.correct ?
                           "<answer><user>" + evaluation.userAnswer + "</user><correct></correct></answer>" :
                           "<answer><user>" + evaluation.userAnswer + "</user>" +
                           "<correct>" + evaluation.correctAnswer + "</correct></answer>";
        return this.session.sendBookSessionData({
            "questionSessionList": [{
                "duration": {"durationTime": duration},
                "questionId": this.retrieveQuestionIndex(entry),
                "dbId": Number(entry.id),
                "point": 0,
                "questionCatelog": entry.presentation === Scilearn.QUIZ_QUESTION ? "QuizQuestion" : "ThinkAboutQuestion",
                "questionType": entry.type,
                "questionState": evaluation.correct ? "AnsweredCorrectly" : "AnsweredIncorrectly",
                "answer": uploadAnswer,
                "skill": entry.skill,
                "thinking": entry.thinking
            }]
        }, successCallback);
    }

    private mapToOriginalIndices(entry: IQuestionEntry, answers:string):string {
        let questionIndex = this.retrieveQuestionIndex(entry);
        let originalEntry:IQuestionEntry = (entry.presentation === Scilearn.QUIZ_QUESTION) ? this.quizEntriesOriginal[questionIndex] :
            this.taqEntriesOriginal[questionIndex];
        let answerIndices:number[] = answers.split(",").map((a) => Number(a));
        let originalAnswerIndices:string[] = [];
        answerIndices.forEach((randomizedIndex) => {
            let answer = <IAnswerModel>JSON.parse(JSON.stringify(entry.answers[randomizedIndex]));
            delete answer.hilited;
            delete answer.selected;
            delete answer.tried;
            let originalIndex = this.findOriginalAnswerIndex(originalEntry, answer);
            originalAnswerIndices.push(originalIndex);
        });
        return originalAnswerIndices.sort((a, b) => { return Number(a) - Number(b); }).join(",");
    }

    private findOriginalAnswerIndex(originalEntry: IQuestionEntry, answer: IAnswerModel): string {
        let originalIndex = -1;
        originalEntry.answers.forEach((a, index) => {
            if (JSON.stringify(a) === JSON.stringify(answer)) {
                originalIndex = index;
            }
        });
        return originalIndex.toString();
    }

    private determineTaqEntries(isPipeline: boolean): IQuestionEntry[] {
        let taqs: IQuestionEntry[] = this.questionEntries.filter(entry => entry.presentation === Scilearn.THINK_ABOUT_IT);
        this.taqEntriesOriginal = JSON.parse(JSON.stringify(taqs));
        if (!isPipeline) {
            taqs.forEach(question => this.answerPresentationService.setupPresentationOrder(question));
        }
        return taqs;
    }

    private determineQuizEntries(isPipeline: boolean):IQuestionEntry[] {
        let quiz:IQuestionEntry[] = this.questionEntries.filter(entry => entry.presentation === Scilearn.QUIZ_QUESTION);
        this.quizEntriesOriginal = JSON.parse(JSON.stringify(quiz));
        if (!isPipeline) {
            quiz.forEach(quiz => this.answerPresentationService.setupPresentationOrder(quiz));
        }
        return quiz;
    }

}
